import React, { useEffect, useState } from 'react';
import { SelectSourcePopup } from './SelectSourcePopup';
import { SelectSource } from './SelectSource';

export function Main(props : any) {

  const { axios , getDriveFileData, onDragStart, onDragEnd} = props

  const [screenSize, setScreenSize] = useState(false)

  function getScreenWidth(){
  let data =  false;

  if ([
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)) {
    data = true;
  }
  setScreenSize(data);
  }

useEffect(() => {
  console.log('platform',navigator.platform)
  console.log('userAgend', navigator.userAgent)
  getScreenWidth()
}, [])

  return (
    <div>
        {
          screenSize === true ? <SelectSource axios={axios} getDriveFileData={getDriveFileData} /> : <SelectSourcePopup screenSize={screenSize} getDriveFileData={getDriveFileData} onDragStart={onDragStart} onDragEnd={onDragEnd}/>
        }
    </div>
  );
}